module.exports = __webpack_public_path__ + "img/globient.12a48793.png";